<template>
    <div class="upload">
        <el-upload
            v-bind:action="fileUploadPath"
            v-bind:headers="headers"
            v-bind:multiple="multiple"
            :show-file-list="false"
            v-bind:limit="limit"
            v-bind:accept="getAccept"
            v-bind:data="data"
            :on-progress="handleProgress"
            :on-success="handleSuccess"
            :on-exceed="handleExceed"
            :on-error="handleError">
            <!-- 插槽 -->
            <slot>
            </slot>
        </el-upload>

        <el-dialog title="上传进度">
        </el-dialog>
    </div>
</template>

<script>
import {fileUploadPath} from "@/api/system/file"
export default {
    props:{
        fileType:{
            type:String,
            default: 'image'
        },
        multiple:{
            type:Boolean,
            default: true
        },
        // 多选时最多选择几条
        limit: {
            type: Number,
            default: 10
        },
        // 上传时的额外参数
        data: {
            type: Object,
            default: () => ({})
        },
        // 是否显示上传进度
        showProgress: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            fileUploadPath, //上传路径
            headers:{},
        }
    },
    created(){
        console.log(this.fileUploadPath);
    },  
    computed:{
        getAccept(){
            switch (this.fileType) {
                case 'image':
                    return '.jpg,.png,.gif,.jpeg,.ico,.bmp'
                case 'video':
                    return '.wmv,.avi,.mov,.mp4,.flv,.rmvb'
                default:
                    return '*'
            }
        }    
    },
    methods:{
        handleProgress(){

        },
        //上传成功
        handleSuccess(){
            this.$emit('change'); //上传成功
        },
        handleExceed(){

        },
        handleError(){

        }
    }
}
</script>

<style lang="scss" scoped>
    .upload{
        margin-right:16px;
        // margin-left: 16px;
    }
</style>